/* Common Imports */
import React from "react";
import { makeStyles } from "@material-ui/core/styles";

/* Component Imports */
import { Typography } from "@material-ui/core";

/* Data Imports */
import AppConfig from "../../AppConfig";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    boxShadow:
      "0px 0px 2px rgba(0, 0, 0, 0.14), 0px 2px 2px rgba(0, 0, 0, 0.12), 0px 1px 3px rgba(0, 0, 0, 0.2)",
    borderRadius: "0.375rem",
    height: "10rem",
    width: "10rem",
    [theme.breakpoints.down("xs")]: {
      height: "8rem",
      width: "8rem",
    },
  },
  title: {
    color: "#202020",
    fontWeight: 400,
    fontSize: "1rem",
    lineHeight: "1.25rem",
    padding: "0.5rem 1rem 0rem 1rem",
    [theme.breakpoints.down("xs")]: {
      fontSize: "0.8rem",
    },
  },
  icon: {
    height: "64px",
    width: "64px",
    [theme.breakpoints.down("xs")]: {
      height: "42px",
      width: "42px",
    },
  },
}));

const DispenseIcon = (iconString) => {
  switch (iconString) {
    case "amenities/joggingtrack":
      return "/images/icons/amenities/jogging_track.svg";
    case "amenities/swimming":
      return "/images/icons/amenities/swimming.svg";
    case "amenities/club":
      return "/images/icons/amenities/club.svg";
    case "amenities/powerbackup":
      return "/images/icons/amenities/power_backup.svg";
    case "amenities/park":
      return "/images/icons/amenities/park.svg";
    case "amenities/rainwater":
      return "/images/icons/amenities/rainwater_harvesting.svg";
    case "amenities/security":
      return "/images/icons/amenities/security.svg";
    case "amenities/gym":
      return "/images/icons/amenities/gym.svg";
    case "amenities/cctv":
      return "/images/icons/amenities/cctv.svg";
    case "amenities/amphitheatre":
      return "/images/icons/amenities/amphitheatre.svg";
    case "amenities/yoga":
      return "/images/icons/amenities/yoga.svg";
    case "amenities/landscape":
      return "/images/icons/amenities/landscape_garden.svg";
    case "amenities/play":
      return "/images/icons/amenities/play_area.svg";
    case "amenities/stp":
      return "/images/icons/amenities/stp.svg";
    case "amenities/mall":
      return "/images/icons/vicinity/mall.svg";
    case "amenities/tennis":
      return "/images/icons/amenities/indoor_games.svg";
    case "amenities/basketball":
      return "/images/icons/amenities/basketball_court.svg";
    case "amenities/lift":
      return "/images/icons/amenities/lift.svg";
    case "amenities/badminton":
      return "/images/icons/amenities/badminton_court.svg";
    case "amenities/canteen":
      return "/images/icons/amenities/canteen.svg";
    case "amenities/twocarparking":
      return "/images/icons/amenities/two_car_parking.svg";
    case "amenities/parking":
      return "/images/icons/amenities/parking.svg";
    case "amenities/gatedcommunity":
      return "/images/icons/amenities/gated_community.svg";
    case "amenities/electricity":
      return "/images/icons/amenities/electricity.svg";
    case "amenities/vastucompliant":
      return "/images/icons/amenities/vastu.svg";
    case "amenities/servicestaff":
      return "/images/icons/amenities/service_staff.svg";
    case "amenities/squash":
      return "/images/icons/amenities/squash_court.svg";
    case "amenities/library":
      return "/images/icons/amenities/library.svg";
    case "amenities/card":
      return "/images/icons/amenities/card_room.svg";
    case "amenities/tenniscourt":
      return "/images/icons/amenities/tennis_court.svg";
    case "amenities/party":
      return "/images/icons/amenities/party_hall.svg";
    case "amenities/cricket":
      return "/images/icons/amenities/cricket.svg";
    case "amenities/aerobics":
      return "/images/icons/amenities/aerobics_room.svg";
    case "amenities/jacuzzi":
      return "/images/icons/amenities/jacuzzi.svg";
    case "amenities/meditation":
      return "/images/icons/amenities/meditation_room.svg";
    case "amenities/volleyball":
      return "/images/icons/amenities/volleyball_court.svg";
    case "amenities/cycle":
      return "/images/icons/amenities/cycle_track.svg";
    case "amenities/kidspool":
      return "/images/icons/amenities/kids_pool.svg";
    case "amenities/spa":
      return "/images/icons/amenities/spa.svg";
    case "amenities/snooker":
      return "/images/icons/amenities/snooker.svg";
    case "amenities/skating":
      return "/images/icons/amenities/skating.svg";
    case "amenities/creche":
      return "/images/icons/amenities/creche.svg";
    case "amenities/sports":
      return "/images/icons/amenities/sports.svg";
    case "amenities/smarthome":
      return "/images/icons/amenities/smart_home.svg";
    case "amenities/earth":
      return "/images/icons/amenities/earthquake_resistant.svg";
    case "amenities/escalator":
      return "/images/icons/amenities/escalator.svg";
    case "amenities/airport":
      return "/images/icons/amenities/airport.svg";
    case "amenities/atm":
      return "/images/icons/amenities/atm.svg";
    case "amenities/bareshell":
      return "/images/icons/amenities/bare_shell.svg";
    case "amenities/childrenfriendly":
      return "/images/icons/amenities/children_friendly.svg";
    case "amenities/communityliving":
      return "/images/icons/amenities/community_living.svg";
    case "amenities/firesafety":
      return "/images/icons/amenities/fire_safety.svg";
    case "amenities/fullyfurnished":
      return "/images/icons/amenities/fully_furnished.svg";
    case "amenities/highway":
      return "/images/icons/amenities/highway_access.svg";
    case "amenities/lounge":
      return "/images/icons/amenities/lounge.svg";
    case "amenities/metro":
      return "/images/icons/amenities/metro.svg";
    case "amenities/openspace":
      return "/images/icons/amenities/open_space.svg";
    case "amenities/petfriendly":
      return "/images/icons/amenities/pet_friendly.svg";
    case "amenities/semifurnished":
      return "/images/icons/amenities/semi_furnished.svg";
    case "amenities/visitorspark":
      return "/images/icons/amenities/visitors_park.svg";
    case "amenities/watersofteningtank":
      return "/images/icons/amenities/water_softening_tank.svg";
    case "amenities/carrom":
      return "/images/icons/amenities/carrom.svg";
    case "amenities/conference":
      return "/images/icons/amenities/conference_room.svg";
    case "amenities/barbecue":
      return "/images/icons/amenities/barbecue.svg";
    case "amenities/banquet":
      return "/images/icons/amenities/banquet_hall.svg";

    default:
      return "/images/icons/post-requirement/agricultural.svg";
  }
};

const AmenitiesCard = (props) => {
  const classes = useStyles();
  return (
    <React.Fragment>
      <div className={classes.root}>
        <img
          alt={AppConfig.imageAltText}
          loading="lazy"
          referrerPolicy="no-referrer"
          height={64}
          width={64}
          className={classes.icon}
          src={DispenseIcon(props.icon ? props.icon : "amenities/card")}
        />
        <Typography
          variant="h6"
          component="h6"
          align="center"
          className={classes.title}
        >
          {props.title}
        </Typography>
      </div>
    </React.Fragment>
  );
};

export default AmenitiesCard;
